import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import type { AppDispatch } from '@/app/store/store';
import { physicalStoreBuild } from '@/shared/features/physical-store/config/physicalStore.build';
import { DEFAULT_STORE_LOCATOR_CITY } from '@/shared/features/physical-store/constants';
import { useStoreLocator } from '@/shared/features/physical-store/presentation/hooks/useStoreLocator';
import { StoreLocatorShell } from '@/shared/features/physical-store/presentation/components/StoreLocatorShell';
import { StoreSeoHead } from '@/shared/features/physical-store/presentation/components/StoreSeoHead';

export default function StorePage() {
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();
  const { service } = useMemo(() => physicalStoreBuild(dispatch), [dispatch]);
  const { cityGroups, isLoading, storeCount, seoSchema } = useStoreLocator({ service });

  const initialCityName =
    searchParams.get('city')?.trim() ||
    searchParams.get('cityName')?.trim() ||
    DEFAULT_STORE_LOCATOR_CITY;

  useEffect(() => {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
    return () => {
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
    };
  }, []);

  return (
    <>
      <StoreSeoHead seoSchema={seoSchema} />
      <StoreLocatorShell
        key={initialCityName}
        service={service}
        cityGroups={cityGroups}
        isLoading={isLoading}
        storeCount={storeCount}
        initialCityName={initialCityName}
      />
    </>
  );
}
